import {
  $get,
  $post
} from '@/utils/http'

export default {
  // 获取图片基础路径
  getIp() {
    return $post('/common/serverUrl')
  },
  // 获取首页BANNER图，三个公用一个接口
  getbanner(params) {
    return $post('/portal/websit/portalPic/getPortalPic', params)
  },
  // 获取情分论坛
  getforusPic(params) {
    return $post('/portal/websit/portalPic/getForumPic', params)
  },
  // 获取举报信息
  getreport(params) {
    return $post('/portal/websit/portalPic/getComplainPic', params)
  },
  // 获取首页轮播图
  getRotation(params) {
    return $post('/portal/websit/rotationChartManager/listPic', params)
  },
  // 获取友情链接
  getFriendList(params) {
    return $post('/portal/websit/outurl/listOutUrl', params)
  },
  // 获取党纪法规
  getLawListdangji(params) {
    return $post('/portal/websit/classificationSystem/listClassificationo', params)
  },
  // 用户登陆接口
  login(params) {
    return $post('/admin/sys/self/login', params)
  },
  // 用户登陆接口
  personal(params) {
    return $post('/admin/sys/self/detail', params)
  },
  // 用户登chu
  personalgoback(params) {
    return $post('/admin/sys/self/logout', params)
  },
}


